import { render, staticRenderFns } from "./contactList.vue?vue&type=template&id=3b137b0f&scoped=true"
import script from "./contactList.vue?vue&type=script&lang=js"
export * from "./contactList.vue?vue&type=script&lang=js"
import style0 from "./contactList.vue?vue&type=style&index=0&id=3b137b0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b137b0f",
  null
  
)

export default component.exports